import styled from 'styled-components'

export const ComparedDataRow = styled.div`
  padding: 7px 10px 10px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 3px;
  font-size: 16px;

  .row-item {
    display: flex;
    flex-direction: row;
  }

  .word-hint {
    display: flex;
    align-items: flex-start;
    padding: 2px 0;
    margin-right: 10px;

    > span > span {
      margin-top: 1px;
      margin-left: 5px;
    }
  }

  &.bestValue {
    background-color: ${ (props) =>
      props.theme.colors.compareBestValueIndicator };

    @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
      height: 100%;
    }
  }

  &.first-paragraph-margin .withOutTooltip > p:first-child {
    margin-bottom: 10px;
  }

  .dataRow {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
    flex-wrap: wrap;
    padding: 2px 0;

    .row-item {
      display: flex;
      flex-direction: row;
      width: 100%;
      justify-content: space-between;
    }

    .bar-graph {
      max-width: 250px;
    }

    &.withOutTooltip {
      > p {
        width: 90%;
      }
    }

    ul.service-list {
      list-style: none;
      margin: 0;
      padding: 0;
      width: 90%;

      li {
        margin: 0 0 0 0;
      }
    }

    @media ${ (props) => props.theme.breakpoints.devices.max.md } {
      margin-top: 10px;
    }

    .checkmark-icon {
      color: ${ (props) => props.theme.colors['aok-gruen'] };
      margin-left: 5px;

      @media ${ (props) => props.theme.breakpoints.devices.max.sm }, print {
        margin: 0 10px 0 0;
      }
    }
  }
`
